import { PLAYLIST_LOCAL_STORAGE_ENTITY_NAME } from "../../EntityNames";
import LocalStoragePersistence from "../../common/LocalStoragePersistence";
import { DtoLocalStoragePersistence } from "../../common/DtoLocalStoragePersistence";
import EntityLocalStorageKey from "../../common/EntityLocalStorageKey";
import { DtoId } from "../../../dto/DtoId";
import {
  PlaylistDTO,
  PlaylistDTOCompanion,
} from "../../../dto/v4/playlist/PlaylistDTO";

export const ERROR_MESSAGE_COULD_NOT_READ_PLAYLIST =
  "Could not read playlist. Ignoring it while reading all playlists.";

export class PlaylistLocalStoragePersistence extends DtoLocalStoragePersistence<PlaylistDTO> {
  protected schemaVersion(): number {
    return PlaylistDTOCompanion.SCHEMA_VERISON;
  }

  protected buildFromParsedJson(parsedJson: PlaylistDTO): PlaylistDTO {
    return PlaylistDTOCompanion.fromParsedJson(parsedJson);
  }

  /**
   * Playlists which are marked as removed, are filtered out.
   */
  public loadAll(): ReadonlyArray<PlaylistDTO> {
    return PlaylistLocalStoragePersistence.loadAllIdentifiers()
      .map((i: string) => {
        const data: PlaylistDTO | undefined = this.load(i)
          .orTee((e) => console.error(ERROR_MESSAGE_COULD_NOT_READ_PLAYLIST, e))
          .unwrapOr(undefined);
        return data && !data.isRemoved ? data : undefined;
      })
      .filter((data): data is PlaylistDTO => data !== undefined);
  }

  public persist(playlist: PlaylistDTO) {
    console.debug(
      `Persisting identifier=${playlist.id} schemaVersion=${playlist.schemaVersion} title=${playlist.title}`,
      playlist,
    );
    LocalStoragePersistence.persist(
      this.localStorageKey(playlist.id),
      playlist,
    );
  }

  protected localStorageKey(identifier: DtoId): EntityLocalStorageKey {
    return new EntityLocalStorageKey(
      PLAYLIST_LOCAL_STORAGE_ENTITY_NAME,
      identifier,
    );
  }

  /**
   * Be aware: Also identifiers of removed playlists are returned here!
   */
  public static loadAllIdentifiers(): ReadonlyArray<string> {
    return LocalStoragePersistence.loadAllIdentifiersForEntity(
      PLAYLIST_LOCAL_STORAGE_ENTITY_NAME,
    );
  }
}
